<template>
  <div>
    <nav-bar />
    <!-- toggle chart/grid ###################################### -->
    <template>
      <v-footer color="transparent" padless class="justify-center br-invert">
        <v-card elevation="8" class="pt-3 pb-4 px-4 footer-card">
          <v-btn
            @click="showCharts = false"
            :color="!showCharts ? 'secondary' : 'var(--gray-light)'"
            rounded
            large
            depressed
            class="px-6 mr-1 white--text footer-border-left"
          >
            <v-icon size="22">fal fa-table</v-icon>
          </v-btn>
          <v-btn
            @click="showCharts = true"
            :color="showCharts ? 'secondary' : 'var(--gray-light)'"
            rounded
            large
            depressed
            class="px-6 ml-1 white--text footer-border-right"
          >
            <v-icon size="22">fas fa-chart-pie</v-icon>
          </v-btn>
        </v-card>
      </v-footer>
    </template>
    <v-container class="mt-10 pt-5">
      <!-- Page Header ########################################### -->
      <v-container pb-0>
        <v-row align="end" class="justify-space-between align-center">
          <v-col cols="12" md="6">
            <div class="page-title">
              <a href="/doacoes/minhas"
                ><v-icon class="mr-3">fal fa-user-chart</v-icon></a
              >
              <h1>Painel</h1>
            </div>
          </v-col>
          <v-col class="text-right" cols="12" md="6">
            <v-menu offset-y left>
              <template v-slot:activator="{ on }">
                <v-btn
                  fab
                  text
                  v-on="on"
                  outlined
                  rounded
                  color="var(--gray)"
                  class="mr-2"
                  height="44"
                  :loading="loading"
                >
                  <v-icon size="14">fas fa-download</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="downloadExcel()">
                  <v-list-item-title>
                    <!-- <v-icon>fal fa-file-excel</v-icon> -->
                    Excel
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadCSV()">
                  <v-list-item-title>
                    <!-- <v-icon>fal fa-file-csv</v-icon> -->
                    CSV
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-btn
              text
              outlined
              rounded
              large
              class="px-12"
              color="var(--gray)"
              @click="showFilterDialog = true"
              :loading="loading"
              >Filtrar</v-btn
            >
          </v-col>
        </v-row>
      </v-container>

      <v-form v-show="showCharts">
        <!-- Total Doado ###################################### -->
        <v-container>
          <v-row>
            <v-col cols="12" lg="6">
              <!-- Card-1 -->
              <v-card class="fill-height" elevation="8">
                <!--card title-->
                <v-card-title class="pb-0 b-b-1">
                  <v-container class="d-flex align-center">
                    <span class="list-labels">Total doado</span>
                  </v-container>
                </v-card-title>

                <!--card content-->
                <v-card-text class="pa-0">
                  <v-container fluid pa-0>
                    <v-row>
                      <v-col class="text-center pa-8">
                        <div class="d-flex flex-column" v-if="!loading">
                          <span
                            class="purple--text secondary--text span-dashboard"
                          >
                            {{
                              (dashboardDetails.mainRibbonResult
                                .donationDonorTotal +
                                dashboardDetails.mainRibbonResult
                                  .donationCompanyTotal +
                                dashboardDetails.mainRibbonResult
                                  .donationAnonymousTotal)
                                | FormatMoney
                            }}
                          </span>
                          <span class="list-labels">geral</span>
                        </div>
                        <v-progress-circular
                          v-else
                          :value="20"
                          indeterminate
                          color="#704DFA"
                        ></v-progress-circular>
                      </v-col>
                      <v-divider vertical class="divider-vertical"></v-divider>
                      <v-col class="text-center pa-8">
                        <div class="d-flex flex-column" v-if="!loading">
                          <span
                            class="purple--text secondary--text span-dashboard"
                          >
                            {{
                              dashboardDetails.mainRibbonResult
                                .donationDonorTotal | FormatMoney
                            }}
                          </span>
                          <span class="list-labels">pessoa física</span>
                        </div>
                        <v-progress-circular
                          v-else
                          :value="20"
                          indeterminate
                          color="#704DFA"
                        ></v-progress-circular>
                      </v-col>
                      <v-divider vertical class="divider-vertical"></v-divider>
                      <v-col class="text-center pa-8">
                        <div class="d-flex flex-column" v-if="!loading">
                          <span
                            class="purple--text secondary--text span-dashboard"
                          >
                            {{
                              dashboardDetails.mainRibbonResult
                                .donationCompanyTotal | FormatMoney
                            }}
                          </span>
                          <span class="list-labels">pessoa jurídica</span>
                        </div>
                        <v-progress-circular
                          v-else
                          :value="20"
                          indeterminate
                          color="#704DFA"
                        ></v-progress-circular>
                      </v-col>
                      <v-divider vertical class="divider-vertical"></v-divider>
                      <v-col class="text-center pa-8">
                        <div class="d-flex flex-column" v-if="!loading">
                          <span
                            class="purple--text secondary--text span-dashboard"
                          >
                            {{
                              dashboardDetails.mainRibbonResult
                                .donationAnonymousTotal | FormatMoney
                            }}
                          </span>

                          <span class="list-labels">anônimo</span>
                          <span class="list-labels" v-if="showAnonymousDetails"
                            >PF -
                            {{
                              dashboardDetails.mainRibbonResult
                                .donationAnonymousDonorTotal | FormatMoney
                            }}
                            / PJ -
                            {{
                              dashboardDetails.mainRibbonResult
                                .donationAnonymousCompanyTotal | FormatMoney
                            }}
                          </span>
                        </div>
                        <v-progress-circular
                          v-else
                          :value="20"
                          indeterminate
                          color="#704DFA"
                        ></v-progress-circular>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
            <!-- Quantidade Doações ###################################### -->
            <v-col cols="12" lg="6">
              <!-- Card-2 -->
              <v-card class="fill-height" elevation="8">
                <!--card title-->
                <v-card-title class="pb-0 b-b-1">
                  <v-container class="d-flex align-center">
                    <span class="list-labels">Quantidade Doações</span>
                  </v-container>
                </v-card-title>

                <!--card content-->
                <v-card-text class="pa-0">
                  <v-container fluid pa-0>
                    <v-row>
                      <v-col class="text-center pa-8">
                        <div class="d-flex flex-column" v-if="!loading">
                          <span
                            class="purple--text secondary--text span-dashboard"
                          >
                            {{
                              dashboardDetails.mainRibbonResult
                                .donationDonorQty +
                                dashboardDetails.mainRibbonResult
                                  .donationCompanyQty +
                                dashboardDetails.mainRibbonResult
                                  .donationAnonymousQty
                            }}
                          </span>
                          <span class="list-labels">geral</span>
                        </div>
                        <v-progress-circular
                          v-else
                          :value="20"
                          indeterminate
                          color="#704DFA"
                        ></v-progress-circular>
                      </v-col>
                      <v-divider vertical class="divider-vertical"></v-divider>
                      <v-col class="text-center pa-8">
                        <div class="d-flex flex-column" v-if="!loading">
                          <span
                            class="purple--text secondary--text span-dashboard"
                          >
                            {{
                              dashboardDetails.mainRibbonResult.donationDonorQty
                            }}
                          </span>
                          <span class="list-labels">pessoa física</span>
                        </div>
                        <v-progress-circular
                          v-else
                          :value="20"
                          indeterminate
                          color="#704DFA"
                        ></v-progress-circular>
                      </v-col>
                      <v-divider vertical class="divider-vertical"></v-divider>
                      <v-col class="text-center pa-8">
                        <div class="d-flex flex-column" v-if="!loading">
                          <span
                            class="purple--text secondary--text span-dashboard"
                          >
                            {{
                              dashboardDetails.mainRibbonResult
                                .donationCompanyQty
                            }}
                          </span>
                          <span class="list-labels">pessoa jurídica</span>
                        </div>
                        <v-progress-circular
                          v-else
                          :value="20"
                          indeterminate
                          color="#704DFA"
                        ></v-progress-circular>
                      </v-col>
                      <v-divider vertical class="divider-vertical"></v-divider>
                      <v-col class="text-center pa-8">
                        <div class="d-flex flex-column" v-if="!loading">
                          <span
                            class="purple--text secondary--text span-dashboard"
                          >
                            {{
                              dashboardDetails.mainRibbonResult
                                .donationAnonymousQty
                            }}
                          </span>
                          <span class="list-labels">anônimo</span>
                          <span class="list-labels" v-if="showAnonymousDetails"
                            >PF -
                            {{
                              dashboardDetails.mainRibbonResult
                                .donationAnonymousDonorQty
                            }}
                            / PJ -
                            {{
                              dashboardDetails.mainRibbonResult
                                .donationAnonymousCompanyQty
                            }}
                          </span>
                        </div>
                        <v-progress-circular
                          v-else
                          :value="20"
                          indeterminate
                          color="#704DFA"
                        ></v-progress-circular>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <v-container v-if="dashboardDetails.donations.length">
        <!-- Gráfico Linhas ###################################### -->
        <v-container>
          <!-- Card-3 -->
          <v-card elevation="8">
            <!--card title-->
            <v-card-title class="pb-0">
              <v-container>
                <span class="list-labels">Histórico</span>
              </v-container>
            </v-card-title>

            <!--card content-->
            <v-card-text>
              <v-container py-0>
                <v-row class="pt-6">
                  <v-col class="text-center">
                    <LineChart
                      width="100%"
                      :series="[
                        dashboardDetails.qtyDonationLineChart,
                        dashboardDetails.totalDonationLineChart
                      ]"
                      :labels="['Quantidade', 'Valor']"
                      :loading="loading"
                    ></LineChart>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>

        <!-- Gráfico Colunas - Secretaria ###################################### -->
        <v-container>
          <!-- Card-4 -->
          <v-card elevation="8">
            <!--card title-->
            <v-card-title class="pb-0">
              <v-container>
                <span class="list-labels">Total Doado - Secretaria</span>
              </v-container>
            </v-card-title>

            <!--card content-->
            <v-card-text>
              <v-container py-0>
                <v-row class="pt-6">
                  <v-col class="text-center">
                    <Chart
                      :colors="['#704DFAFF', '#704DFA7F']"
                      :value="dashboardDetails.secretaryBarChart"
                      :loading="loading"
                    >
                    </Chart>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>

        <!-- Gráfico Colunas - Conselho ###################################### -->
        <v-container>
          <!-- Card-4 -->
          <v-card elevation="8">
            <!--card title-->
            <v-card-title class="pb-0">
              <v-container>
                <span class="list-labels">Total Doado - Conselho</span>
              </v-container>
            </v-card-title>

            <!--card content-->
            <v-card-text>
              <v-container py-0>
                <v-row class="pt-6">
                  <v-col class="text-center">
                    <Chart
                      :colors="['#704DFAFF', '#704DFA7F']"
                      :value="dashboardDetails.councilBarChart"
                      :loading="loading"
                    >
                    </Chart>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>

        <!-- Gráfico Colunas - Instituição ###################################### -->
        <v-container>
          <!-- Card-4 -->
          <v-card elevation="8">
            <!--card title-->
            <v-card-title class="pb-0">
              <v-container>
                <span class="list-labels">Total Doado - Instituição</span>
              </v-container>
            </v-card-title>

            <!--card content-->
            <v-card-text>
              <v-container py-0>
                <v-row class="pt-6">
                  <v-col class="text-center">
                    <Chart
                      :colors="['#704DFAFF', '#704DFA7F']"
                      :value="dashboardDetails.institutionBarChart"
                      :loading="loading"
                    >
                    </Chart>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>

        <!-- Gráfico Pizza - Forma de Pagamento ###################################### -->
        <v-container>
          <!-- Card-4 -->
          <v-card elevation="8">
            <!--card title-->
            <v-card-title class="pb-0">
              <v-container>
                <span class="list-labels"
                  >Total Doado - Forma de Pagamento</span
                >
              </v-container>
            </v-card-title>

            <!--card content-->
            <v-card-text>
              <v-container py-0>
                <v-row class="pt-6">
                  <v-col class="text-center">
                    <Chart
                      :colors="['#704DFA', '#5DCEF2', '#F2774C']"
                      :value="dashboardDetails.paymentMethodPieChart"
                      chartType="pie"
                      :loading="loading"
                    >
                    </Chart>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>

        <!-- Gráfico Colunas - Instituição ###################################### -->
        <v-container>
          <!-- Card-4 -->
          <v-card elevation="8">
            <!--card title-->
            <v-card-title class="pb-0">
              <v-container>
                <span class="list-labels">Total Doado - UF Agente</span>
              </v-container>
            </v-card-title>

            <!--card content-->
            <v-card-text>
              <v-container py-0>
                <v-row class="pt-6">
                  <v-col class="text-center">
                    <Chart
                      :colors="['#704DFAFF', '#704DFA7F']"
                      :value="dashboardDetails.agentStateBarChart"
                      :loading="loading"
                    >
                    </Chart>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>

        <!-- Gráfico Colunas - Instituição ###################################### -->
        <v-container>
          <!-- Card-4 -->
          <v-card elevation="8">
            <!--card title-->
            <v-card-title class="pb-0">
              <v-container>
                <span class="list-labels">Total Doado - UF Doador</span>
              </v-container>
            </v-card-title>

            <!--card content-->
            <v-card-text>
              <v-container py-0>
                <v-row class="pt-6">
                  <v-col class="text-center">
                    <Chart
                      :colors="['#704DFAFF', '#704DFA7F']"
                      :value="dashboardDetails.donorStateBarChart"
                      :loading="loading"
                    >
                    </Chart>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>
        </v-container>
      </v-form>
      <v-form v-show="!showCharts">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-data-table
                class="br-4 no-wrap table-traduction mb-2"
                :headers="headers"
                :items="dashboardDetails.donations"
                item-key="id"
                no-data-text="Nenhum resultado encontrado"
                :loading="loading"
              >
                <template v-slot:item.value="{ item }">
                  {{ formatterHelper.formatMoney(item.value) }}
                </template>
                <template v-slot:item.paymentMethod="{ item }">
                  {{ formatterHelper.formatPaymentMethod(item.paymentMethod) }}
                </template>
                <template v-slot:item.donorDocument="{ item }">
                  {{ formatterHelper.formatDocument(item.donorDocument) }}
                </template>
                <template v-slot:item.donationDate="{ item }">
                  {{ formatterHelper.formatDate(item.donationDate) }}
                </template>
                <template v-slot:item.receiptId="{ item }">
                  <v-icon
                        v-if="item.receiptId"
                        title="Baixar recibo"
                        class="fa-2x"
                        @click="signedPreview(item.receiptId)"
                        outlined
                        fab
                        color="danger"
                        >mdi-file-pdf-box</v-icon
                      >
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-container>

    <!-- Modal -->
    <template>
      <v-dialog v-model="showFilterDialog" max-width="490">
        <v-card>
          <v-card-title>
            <h5 class="pt-5 pb-7">Filtrar</h5>
            <v-spacer></v-spacer>
            <v-btn color="secondary" icon @click="closeFilterDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="6">
                <InputDate
                  v-model="startDate"
                  label="De"
                  :maxDate="startDateMax"
                  :disabled="false"
                />
              </v-col>
              <v-col cols="6">
                <InputDate
                  v-model="endDate"
                  label="Até"
                  :minDate="endDateMin"
                  :maxDate="endDateMax"
                  :disabled="false"
                />
              </v-col>
              <v-col cols="12">
                <v-select
                  clearable
                  v-model="selectedPaymentMethods"
                  :items="paymentMethods"
                  label="Forma de Pagto"
                  outlined
                  hide-details="auto"
                  multiple
                  chips
                  item-text="name"
                  item-value="id"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  clearable
                  v-model="selectedSecretaries"
                  :items="dashboardFilters.secretaries"
                  label="Secretarias"
                  outlined
                  hide-details="auto"
                  multiple
                  chips
                  item-text="name"
                  item-value="id"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  clearable
                  v-model="selectedCouncils"
                  :items="dashboardFilters.councils"
                  label="Conselhos"
                  outlined
                  hide-details="auto"
                  multiple
                  chips
                  item-text="name"
                  item-value="id"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  clearable
                  v-model="selectedInstitutions"
                  :items="dashboardFilters.institutions"
                  label="Instituições"
                  outlined
                  hide-details="auto"
                  multiple
                  chips
                  item-text="name"
                  item-value="id"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="lg"></v-divider>
          <v-card-actions class="px-6 py-5">
            <v-btn
              rounded
              outlined
              large
              depressed
              class="px-12 gray"
              @click="clearFilters()"
              >Limpar</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              rounded
              large
              depressed
              class="px-12"
              @click="applyFilters()"
              >Filtrar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NavBar from "@/components/NavBar";
import DonationService from "@/scripts/services/donation.service";
import LineChart from "@/components/charts/LineChart";
import Chart from "@/components/charts/Chart";
import PaymentMethods from "@/scripts/enums/paymentMethods.enum";
import FormatterHelper from "@/scripts/helpers/formatter.helper";
import CommonHelper from "@/scripts/helpers/common.helper";
import XLSX from "xlsx";
export default {
  name: "Configuration",
  components: {
    NavBar,
    LineChart,
    Chart
  },
  data: () => ({
    formatterHelper: FormatterHelper,
    showFilterDialog: false,
    date: new Date().toISOString().substr(0, 10),
    donationService: new DonationService(),
    showCharts: true,
    loading: false,
    dashboardFilters: {
      councils: [],
      secretaries: [],
      institutions: []
    },
    paymentMethods: [
      {
        id: PaymentMethods.BankBillet,
        name: FormatterHelper.formatPaymentMethod(PaymentMethods.BankBillet)
      },
      {
        id: PaymentMethods.BankTransfer,
        name: FormatterHelper.formatPaymentMethod(PaymentMethods.BankTransfer)
      },
      {
        id: PaymentMethods.Darf,
        name: FormatterHelper.formatPaymentMethod(PaymentMethods.Darf)
      }
    ],
    selectedPaymentMethods: [],
    selectedCouncils: [],
    selectedSecretaries: [],
    selectedInstitutions: [],
    startDate: null,
    endDate: null,
    dashboardDetails: {
      //main ribbon data
      mainRibbonResult: {
        donationAnonymousTotal: 0,
        donationAnonymousQty: 0,

        donationCompanyTotal: 0,
        donationCompanyQty: 0,
        donationAnonymousCompanyTotal: 0,
        donationAnonymousCompanyQty: 0,

        donationDonorTotal: 0,
        donationDonorQty: 0,
        donationAnonymousDonorTotal: 0,
        donationAnonymousDonorQty: 0
      },
      //detailed ribbons
      ribbonResultEntityType: 1,
      ribbonResultPerEntity: [],

      //line charts
      totalDonationLineChart: [],
      qtyDonationLineChart: [],

      //bar and pizza charts
      secretaryBarChart: [],
      councilBarChart: [],
      institutionBarChart: [],
      paymentMethodPieChart: [],
      agentStateBarChart: [],
      donorStateBarChart: [],

      //grid information
      donations: []
    }
  }),
  computed: {
    ...mapGetters("userModule", ["loggedEntityId"]),
    headers() {
      return [
        { text: "Id doação", value: "donationId" },
        {
          text: "Data",
          value: "donationDate",
          formatter: this.formatDate
        },
        { text: "Secretaria", value: "secretary" },
        { text: "Conselho", value: "council" },
        { text: "Institutição", value: "institution" },
        { text: "Agente", value: "agent" },
        { text: "Doador", value: "donor" },
        { text: "Email", value: "email" },
        {
          text: "CPF/CNPJ Doador",
          value: "donorDocument",
          formatter: this.formatDocument
        },
        {
          text: "Valor",
          value: "value",
          formatter: FormatterHelper.formatMoney
        },
        {
          text: "Forma de pagamento",
          value: "paymentMethod",
          formatter: FormatterHelper.formatPaymentMethod
        },
        { text: "Boleto", value: "billetReferenceCode" },
        //{
         // text: "Anônima",
          //value: "anonymous",
          //formatter: FormatterHelper.formatBoolean
        //}, 
        {
          text: "Nº Recibo",
          value: "receiptOrderNumber"
        },
        {
          text: "Baixar",
          value: "receiptId"
        }
      ];
    },
    showAnonymousDetails() {
      return (
        this.dashboardDetails.mainRibbonResult.donationAnonymousDonorTotal ||
        this.dashboardDetails.mainRibbonResult.donationAnonymousCompanyTotal
      );
    },
    startDateMax() {
      if (this.endDate) return this.endDate;
      return new Date();
    },
    endDateMin() {
      if (this.startDate) return this.startDate;
      return null;
    },
    endDateMax() {
      return new Date();
    }
  },
  created() {
    this.getDashboardFilters();
    this.getDashboardDetails();
  },
  methods: {
    formatDocument(document) {
      return FormatterHelper.formatDocument(document);
    },
    formatDate(date) {
      return FormatterHelper.formatDate(date);
    },
    getDashboardFilters() {
      this.donationService
        .getDashboardFilters(this.loggedEntityId)
        .then(result => (this.dashboardFilters = result));
    },
    getDashboardDetails() {
      this.loading = true;
      this.donationService
        .getDashboardDetails({
          secretaries: this.selectedSecretaries,
          councils: this.selectedCouncils,
          institutions: this.selectedInstitutions,
          paymentMethods: this.selectedPaymentMethods,
          startDate: this.startDate,
          endDate: this.endDate,
          entityId: parseInt(this.loggedEntityId)
        })
        .then(result => {
          console.log("getDashboardDetails:", result);
          this.dashboardDetails = result;
        })
        .finally(() => (this.loading = false));
    },
    closeFilterDialog() {
      this.showFilterDialog = false;
    },
    applyFilters() {
      this.closeFilterDialog();
      this.getDashboardDetails();
    },
    clearFilters() {
      this.selectedPaymentMethods = [];
      this.selectedSecretaries = [];
      this.selectedCouncils = [];
      this.selectedInstitutions = [];
      this.startDate = null;
      this.endDate = null;
      this.applyFilters();
    },
    downloadCSV() {
      if (this.dashboardDetails.donations.length == 0) {
        CommonHelper.swal("", "Nenhum dado disponível para download.", "error");
        return;
      }
      let text = "";
      let i, j;
      for (i = 0; i < this.headers.length; i++) {
        text += this.headers[i].text + ";";
      }
      text += "\n";

      for (i = 0; i < this.dashboardDetails.donations.length; i++) {
        for (j = 0; j < this.headers.length; j++) {
          let valueToAddToLine = this.dashboardDetails.donations[i][
            this.headers[j].value
          ];
          if (this.headers[j].formatter)
            valueToAddToLine = this.headers[j].formatter(valueToAddToLine);
          text += valueToAddToLine + ";";
        }
        text += "\n";
      }

      var blob = new Blob(["\ufeff" + text], { type: "text/csv" });
      this.save(blob, "csv");
    },
    getWSData() {
      let wsData = [];
      let text = [];
      wsData.push(text);
      let i, j;
      for (i = 0; i < this.headers.length; i++) {
        text.push(this.headers[i].text);
      }
      text = [];
      wsData.push(text);

      for (i = 0; i < this.dashboardDetails.donations.length; i++) {
        for (j = 0; j < this.headers.length; j++) {
          let valueToAddToLine = this.dashboardDetails.donations[i][
            this.headers[j].value
          ];
          if (this.headers[j].formatter)
            valueToAddToLine = this.headers[j].formatter(valueToAddToLine);
          text.push(valueToAddToLine);
        }
        text = [];
        wsData.push(text);
      }
      return wsData;
    },
    generateExcel() {
      if (this.dashboardDetails.donations.length == 0) {
        CommonHelper.swal("", "Nenhum dado disponível para download.", "error");
        return;
      }
      var wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Dados",
        Subject: "Dados",
        Author: "Benfeitores",
        CreatedDate: new Date()
      };
      wb.SheetNames.push("Dados");
      var ws_data = this.getWSData(); //[["hello", "world"]];
      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      wb.Sheets["Dados"] = ws;
      return XLSX.write(wb, { bookType: "xlsx", type: "binary" });
    },
    s2ab() {
      let s = this.generateExcel();
      var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
      var view = new Uint8Array(buf); //create uint8array as viewer
      for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
      return buf;
    },
    downloadExcel() {
      if (this.dashboardDetails.donations.length == 0) {
        CommonHelper.swal("", "Nenhum dado disponível para download.", "error");
        return;
      }
      var blob = new Blob([this.s2ab()], {
        type: "application/octet-stream"
      });
      this.save(blob, "xlsx");
    },
    save(blob, type) {
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, "Dashboard.csv");
      } else {
        var elem = window.document.createElement("a");
        elem.href = window.URL.createObjectURL(blob);
        elem.download = "Dashboard." + type;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }
    },
    signedPreview(receiptId) {
      var url =
        process.env.VUE_APP_API_URL +
        "/Receipt/SignedPreview/?receiptId=" +
        receiptId;
      var link = document.createElement("a");
      link.id = "preview";
      link.href = url;
      link.download;
      link.click();
    }
  }
};
</script>